"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var handleCurry_1 = require("./utils/handleCurry");
var regexp_1 = require("./regexp");
var description_1 = require("./utils/description");
var string_1 = require("./string");
function matches(regexp, value) {
    if (!regexp_1.default(regexp)) {
        throw new TypeError('Regexp must be a RegExp object');
    }
    return handleCurry_1.default.call(this, arguments, description_1.setDescription(function (value) { return string_1.default(value) && regexp.test(value); }, 'a string that matches regexp ' + regexp));
}
exports.default = matches;
